import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faShieldAlt, faEnvelope, faPhone, faSearch, faEdit, faTrash, faDownload, faBan, faLock, faKey, faServer, faSyncAlt } from '@fortawesome/free-solid-svg-icons';

const Privacidad = () => {
  const [openSection, setOpenSection] = useState(null);

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const toggleSection = (sectionId) => {
    setOpenSection(openSection === sectionId ? null : sectionId);
  };

  const privacySections = [
    {
      id: 'introduccion',
      title: 'Nuestro Compromiso con su Privacidad',
      content: (
        <div className="space-y-4">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            En ADASTRA, valoramos profundamente la confianza que deposita en nosotros al compartir su información personal. 
            Esta Política de Privacidad describe cómo recopilamos, usamos, protegemos y compartimos su información cuando 
            utiliza nuestros servicios gastronómicos, ya sea en nuestro restaurante, sitio web o aplicaciones.
          </p>
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Nos comprometemos a ser transparentes sobre nuestras prácticas de datos y a cumplir con todas las 
            regulaciones aplicables de protección de datos.
          </p>
          <div className="bg-green-50 p-6 rounded-xl border-l-4 border-green-600">
            <p className="font-sans text-base text-green-800 font-medium">
              <FontAwesomeIcon icon={faShieldAlt} className="mr-2" />
              Su privacidad es fundamental para la experiencia ADASTRA que queremos ofrecerle.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'informacion-recopilamos',
      title: 'Información que Recopilamos',
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Información Personal Directa</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Datos de reserva:</strong> Nombre, número de teléfono, email, fecha y hora preferida, número de comensales</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Información de pedidos:</strong> Selecciones del menú, preferencias alimentarias, alergias, instrucciones especiales</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Datos de pago:</strong> Información de facturación, métodos de pago (procesados de forma segura)</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Comunicaciones:</strong> Mensajes, comentarios, reseñas y feedback que nos comparte</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Información Técnica</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Datos de navegación:</strong> Dirección IP, tipo de navegador, páginas visitadas, tiempo en el sitio</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Cookies:</strong> Preferencias del sitio, sesiones de usuario, análisis de uso</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'como-usamos',
      title: 'Cómo Usamos su Información',
      content: (
        <div className="space-y-6">
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Servicios Principales</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Procesar y confirmar sus reservas de mesa</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Gestionar pedidos para entrega y recogida</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Personalizar su experiencia gastronómica según sus preferencias</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Procesar pagos de forma segura</span>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Mejora y Comunicación</h4>
            <ul className="space-y-2 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Mejorar nuestros servicios y ofertas gastronómicas</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Enviar actualizaciones sobre su reserva o pedido</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Compartir ofertas especiales y eventos (solo con su consentimiento)</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span>Solicitar feedback sobre su experiencia en ADASTRA</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'cookies',
      title: 'Cookies y Tecnologías',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Utilizamos cookies y tecnologías similares para mejorar su experiencia en nuestro sitio web y servicios.
          </p>
          <div className="grid gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">Cookies Esenciales</h5>
              <p className="text-gray-700 text-sm">Necesarias para el funcionamiento básico del sitio, como mantener su sesión y carrito de compras.</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">Cookies Analíticas</h5>
              <p className="text-gray-700 text-sm">Nos ayudan a entender cómo usa nuestro sitio para mejorarlo (Google Analytics).</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">Cookies de Marketing</h5>
              <p className="text-gray-700 text-sm">Solo se activan con su consentimiento para mostrarle contenido relevante.</p>
            </div>
          </div>
          <p className="font-sans text-sm text-gray-600 italic">
            Puede gestionar sus preferencias de cookies en la configuración de su navegador en cualquier momento.
          </p>
        </div>
      )
    },
    {
      id: 'compartir',
      title: 'Cuándo Compartimos su Información',
      content: (
        <div className="space-y-6">
          <div className="bg-red-50 p-4 rounded-lg border-l-4 border-red-500">
            <p className="font-sans text-red-800 font-medium">
              <strong>Nunca vendemos</strong> su información personal a terceros.
            </p>
          </div>
          <div>
            <h4 className="font-sans text-xl font-semibold text-gray-900 mb-3">Compartimos únicamente cuando es necesario:</h4>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Proveedores de pago:</strong> Stripe, PayPal para procesar transacciones de forma segura</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Servicios de entrega:</strong> Para coordinar la entrega de sus pedidos</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Proveedores de servicios:</strong> Que nos ayudan a operar nuestro negocio (hosting, análisis)</span>
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-green-600 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                <span><strong>Requerimientos legales:</strong> Cuando la ley nos lo exige o para proteger nuestros derechos</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      id: 'derechos',
      title: 'Sus Derechos de Privacidad',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Usted tiene control sobre su información personal. Estos son sus derechos:
          </p>
          <div className="grid gap-4">
            <div className="bg-green-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faSearch} className="text-black mr-2" />
                Derecho de Acceso
              </h5>
              <p className="text-gray-700 text-sm">Solicitar una copia de toda la información personal que tenemos sobre usted.</p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faEdit} className="text-black mr-2" />
                Derecho de Corrección
              </h5>
              <p className="text-gray-700 text-sm">Corregir cualquier información incorrecta o incompleta.</p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faTrash} className="text-black mr-2" />
                Derecho de Eliminación
              </h5>
              <p className="text-gray-700 text-sm">Solicitar la eliminación de su información personal (sujeto a obligaciones legales).</p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faDownload} className="text-black mr-2" />
                Derecho de Portabilidad
              </h5>
              <p className="text-gray-700 text-sm">Recibir sus datos en un formato estructurado para transferir a otro servicio.</p>
            </div>
            <div className="bg-green-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faBan} className="text-black mr-2" />
                Derecho de Oposición
              </h5>
              <p className="text-gray-700 text-sm">Oponerse al procesamiento de sus datos para marketing directo.</p>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'seguridad',
      title: 'Cómo Protegemos su Información',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            La seguridad de su información es una prioridad absoluta para ADASTRA. Implementamos múltiples 
            capas de protección:
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faLock} className="text-black mr-2" />
                Encriptación
              </h5>
              <p className="text-gray-700 text-sm">Toda la información sensible se encripta durante la transmisión y almacenamiento.</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faKey} className="text-black mr-2" />
                Acceso Limitado
              </h5>
              <p className="text-gray-700 text-sm">Solo personal autorizado tiene acceso a información personal con necesidad comercial.</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faServer} className="text-black mr-2" />
                Servidores Seguros
              </h5>
              <p className="text-gray-700 text-sm">Utilizamos servidores seguros con firewalls y monitoreo continuo.</p>
            </div>
            <div className="bg-gray-50 p-4 rounded-lg">
              <h5 className="font-semibold text-gray-900 mb-2">
                <FontAwesomeIcon icon={faSyncAlt} className="text-black mr-2" />
                Actualizaciones
              </h5>
              <p className="text-gray-700 text-sm">Mantenemos nuestros sistemas de seguridad actualizados regularmente.</p>
            </div>
          </div>
          <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-500">
            <p className="font-sans text-yellow-800 text-sm">
              <strong>Importante:</strong> Aunque implementamos medidas de seguridad robustas, ningún sistema es 100% seguro. 
              Le recomendamos también proteger su información personal y notificarnos inmediatamente si sospecha algún uso no autorizado.
            </p>
          </div>
        </div>
      )
    },
    {
      id: 'contacto',
      title: 'Contacto sobre Privacidad',
      content: (
        <div className="space-y-6">
          <p className="font-sans text-lg text-gray-700 leading-relaxed">
            Si tiene preguntas sobre esta Política de Privacidad o desea ejercer sus derechos de privacidad, 
            no dude en contactarnos:
          </p>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
              <h4 className="font-sans text-xl font-semibold text-gray-900 mb-4">Información de Contacto</h4>
              <div className="space-y-3">
                <div className="flex items-center space-x-3">
                  <FontAwesomeIcon icon={faEnvelope} className="text-green-600" />
                  <span className="text-gray-700">privacidad@adastra-restaurant.com</span>
                </div>
                <div className="flex items-center space-x-3">
                  <FontAwesomeIcon icon={faPhone} className="text-green-600" />
                  <span className="text-gray-700">+53 6351 8498</span>
                </div>
              </div>
            </div>
            <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
              <h4 className="font-sans text-xl font-semibold text-gray-900 mb-4">Tiempo de Respuesta</h4>
              <p className="text-gray-700 text-sm leading-relaxed">
                Nos comprometemos a responder a todas las consultas de privacidad dentro de 
                <strong> 30 días hábiles</strong>. Para solicitudes urgentes, contáctenos por teléfono.
              </p>
            </div>
          </div>
          <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-500">
            <p className="font-sans text-blue-800 text-sm">
              <strong>Última actualización:</strong> Esta Política de Privacidad fue actualizada por última vez el 
              {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}. 
              Cualquier cambio significativo será comunicado a través de nuestro sitio web y por email.
            </p>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <section className="bg-black pt-60 pb-48">
        <div className="container-custom max-w-4xl mx-auto px-6 text-center">
          <h1 className="font-sans text-4xl md:text-5xl font-light text-white mb-6">
            Política de <span className="font-normal italic text-green-400">Privacidad</span>
          </h1>
          <p className="font-sans text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Transparencia y confianza en cada experiencia gastronómica que compartimos con usted.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20">
        <div className="container-custom max-w-4xl mx-auto px-6">
          <div className="space-y-6">
            {privacySections.map((section) => (
              <div 
                key={section.id} 
                className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden"
              >
                <button
                  onClick={() => toggleSection(section.id)}
                  className="w-full px-8 py-6 text-left hover:bg-gray-50 transition-colors duration-200 flex items-center justify-between"
                >
                  <h3 className="font-sans text-xl md:text-2xl font-light text-gray-900">
                    {section.title}
                  </h3>
                  <FontAwesomeIcon 
                    icon={openSection === section.id ? faChevronUp : faChevronDown} 
                    className="text-gray-500 transition-transform duration-200"
                  />
                </button>
                
                {openSection === section.id && (
                  <div className="px-8 pb-8 border-t border-gray-100">
                    <div className="pt-6">
                      {section.content}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* CTA Section */}
          <div className="mt-16 text-center">
            <div className="bg-green-600 rounded-2xl p-8 text-white">
              <h3 className="font-sans text-2xl md:text-3xl font-light mb-4">
                ¿Preguntas sobre su <span className="font-normal italic">Privacidad</span>?
              </h3>
              <p className="font-sans text-lg text-green-100 mb-6">
                Estamos aquí para ayudarle. Contáctenos para cualquier consulta sobre sus datos personales.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a 
                  href="mailto:privacidad@adastra-restaurant.com"
                  className="bg-white text-green-600 font-semibold py-3 px-8 rounded-xl hover:bg-gray-100 transition-colors duration-300"
                >
                  Enviar Email
                </a>
                <a 
                  href="tel:+5363518498"
                  className="border-2 border-white text-white font-semibold py-3 px-8 rounded-xl hover:bg-white hover:text-green-600 transition-colors duration-300"
                >
                  Llamar Ahora
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacidad;